module.exports = __webpack_public_path__ + "static/media/aprendizagem.a7d5c266.png";